import styled from 'styled-components';

import { Button } from 'components/Button';
import { Table } from 'components/Table';

const Container = styled.div`
  margin: 3rem 0;
`;

const ListTable = styled(Table)`
  th:last-child,
  td:last-child {
    text-align: right;
  }
`;

const AddButton = styled(Button)`
  margin: 4.8rem auto 0 auto;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
`;

export { Container, ListTable, AddButton };
